<app-dialog [loading]="isSaving">
  <ng-container dialog-title>
    <label class="title">{{ 'module.energyMap.descriptionComponent.BuildingHistoryTitleText' | translate }}</label>
  </ng-container>
  <ng-container dialog-content>
    <div class="building-history-dialog">
      <div class="modified-date">
        <p>
          <strong>{{ 'module.energyMap.descriptionComponent.ModifiedDateText' | translate }}</strong>
        </p>
        {{ getProp(buildingData[0], 'gpsModifyDate') | localDate: 'yMMdHm' : true }}
      </div>
      <div class="modified-by">
        <strong>{{ 'module.energyMap.descriptionComponent.ModifiedByText' | translate }}</strong>
        {{ getProp(userData, 'firstname') + ' ' + getProp(userData, 'lastname') }}
      </div>
      <div class="contact-email">
        <strong>{{ 'module.energyMap.descriptionComponent.ModifiedByEmailText' | translate }}</strong>
        {{ getProp(userData, 'email') }}
      </div>
      <div *ngIf="isSaving" class="overlay">
        <span class="fa fa-spinner fa-spin fa-3x"></span>
      </div>
    </div>
  </ng-container>
</app-dialog>
